import fireErrorAnalytics, {
	isNetworkError,
} from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../constants.tsx';

export const SKIP_SENTRY_ERROR_MESSAGES = [
	'Internal error.',
	'Internal error opening backing store for indexedDB.open.',
	"Can't find variable: indexedDB",
	'Error looking up record in object store by key range',
	"IDBDatabase.transaction: 'keyval' is not a known object store name",
	'A mutation operation was attempted on a database that did not allow mutations.',
];

const shouldSkipSentry = (error: Error) =>
	isNetworkError(error) || SKIP_SENTRY_ERROR_MESSAGES.includes(error?.message);

export const errorHandler = (error: Error, source: string) => {
	const cause = error instanceof Error ? error.message : 'Not known';
	fireErrorAnalytics({
		meta: {
			id: source,
			packageName: PACKAGE_NAME,
			teamName: TEAM_NAME,
		},
		error: new Error(`JCL ${source} - ${cause}`, { cause: error }),
		attributes: {
			cause,
		},
		sendToPrivacyUnsafeSplunk: true,
		skipSentry: shouldSkipSentry(error),
	});
};
